<template>
  <div class="orderSubsProfileTab">

    <div class="row">
        <div class="col-lg-12">
            <div class="row">
                <div class="col-md-6">
                    <div class="orderSubProfileItem">
                        <h2>YOUR DETAILS</h2>
                        <h1>{{user ? user.name : ''}}</h1>
                        <h1>{{user ? user.email : '' }}</h1>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="orderSubProfileItem">
                        <h2>
                            <span class="tlabel">PAYMENT METHOD</span> 
                            <span 
                                @click="editcard = true"
                                class="action">
                                <b-icon icon="pencil"></b-icon>
                            </span>
                        </h2>

                        <div :class="['usercreditcards', {'viewmode' : !editcard}]">
                            <b-form-group v-slot="{ ariaDescribedby }">
                                <template v-for="card in usercreditcards">

                                    <b-input-group :key="card.id">

                                        <template #prepend>
                                            <span v-if="card.id == defaultcard" class="defaultcard">
                                                <b-icon icon="credit-card2-back"></b-icon>
                                            </span>
                                        </template>
                                        
                                        <b-form-radio 
                                            :class="[{'defaultcard' : card.id == defaultcard}]"
                                            @change="defaultcardchange(card)"
                                            v-model="defaultcard"
                                            :disabled="!editcard"
                                            :aria-describedby="ariaDescribedby" 
                                            name="creditcards" 
                                            :value="card.id">

                                                

                                            <h1 >
                                                <template v-if="card.card_provider == 'MC'">
                                                    <img src="@/assets/img/mastercard.png" alt=""> 

                                                </template>

                                                <template v-else-if="card.card_provider == 'VISA'">
                                                    <img src="@/assets/img/visalogo.png" alt=""> 
                                                </template>

                                                <template v-else-if="card.card_provider == 'AMEX'">
                                                    <img src="@/assets/img/amex.png" alt=""> 
                                                </template>

                                                <template v-else-if="card.card_provider == 'JCB'">
                                                    <img src="@/assets/img/jcb.jpeg" alt=""> 
                                                </template>
                                                ending in {{card.card_last_four_digit}} {{card.card_expiry | formatcardexpiration}}

                                                <span 
                                                    v-if="!card.is_default && editcard"
                                                    class="removecard" 
                                                    @click="todeletecard = card, $bvModal.show('deletecardwarning')">
                                                    <b-icon icon="trash"></b-icon>
                                                </span>
                                            </h1>
                                        </b-form-radio>
                                    </b-input-group>

                                </template>

                               
                            </b-form-group>

                            <div 
                                v-if="editcard && !newcard"
                                class="cardfooteraction">
                                <button 
                                    @click="editcard = false"
                                    class="btn btn-outline-primary btn-round">
                                    {{usercreditcards.length > 0 ? 'Cancel' : 'Close'}}    
                                </button>

                                <button 
                                    v-if="usercreditcards.length > 0"
                                    @click="setdefault"
                                    class="btn btn-primary">Save</button>
                            </div>
                        </div>

                        <div class="newcardform" v-if="newcard">
                            <h2>New Card</h2>
                            <b-row>
                                <b-col cols="6">
                                    <label>NAME ON CARD</label>

                                    <input 
                                        v-model="cardname" 
                                        type="text" 
                                        placeholder="Name on Card" 
                                        class="form-control">
                                </b-col>

                                <b-col cols="6">
                                    <form name="tokenform" id="tokenform">
                                        <iframe id="tokenFrame" name="tokenFrame" :src="cardconnecturl" frameborder="0" scrolling="no"></iframe>
                                    </form>
                                </b-col>

                                <b-col cols="12">
                                    <div class="newcardactions">
                                        <button 
                                            @click="editcard = false, newcard = false"
                                            class="btn btn-outline-primary btn-round">Close</button>

                                        <button 
                                            @click="newcard = false"
                                            class="btn btn-outline-primary btn-round">Cancel</button>

                                        <button 
                                            :disabled="disablesave"
                                            @click="createcard"
                                            class="btn btn-primary">Save</button>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="orderSubProfileItem">
                        <h2>
                            <span class="tlabel">BILLING ADDRESS</span> 
                            <span 
                                v-if="subscription"
                                @click="initeditbilling"
                                class="action">
                                <b-icon icon="pencil"></b-icon>
                            </span>
                        </h2>
                        <template v-if="subscription">

                            <template v-if="editbilling">
                                <div class="row">
                                    <div class="col-12">
                                        <input
                                            id="autocompletesboxbilling"
                                            v-model="billingaddress.billing_address_street"
                                            type="text"
                                            placeholder="Street Address"
                                            class="form-control"
                                        />
                                    </div>

                                    <div class="col-6">
                                        <input
                                            readonly
                                            v-model="billingaddress.billing_address_city"
                                            type="text"
                                            placeholder="City"
                                            class="form-control"
                                        />
                                    </div>

                                    <div class="col-6">
                                        <input
                                            readonly
                                            v-model="billingaddress.billing_address_state"
                                            type="text"
                                            placeholder="State"
                                            class="form-control"
                                        />
                                    </div>

                                    <div class="col-6">
                                        <input
                                            readonly
                                            v-model="billingaddress.billing_address_zipcode"
                                            type="text"
                                            placeholder="Zip"
                                            class="form-control"
                                        />
                                    </div>

                                    <b-col cols="12">
                                        <div class="editfooteraction">
                                            <button 
                                                @click="editbilling = false"
                                                class="btn btn-outline-primary btn-round">Cancel</button>
                                            <button 
                                                @click="updatebillingaddress"
                                                class="btn btn-primary">Save</button>
                                        </div>
                                    </b-col>
                                </div>
                            </template>

                            <template v-else>
                                <h1>{{subscription.billing_address_street}} {{subscription.billing_address_city}}, {{subscription.billing_address_state}} {{subscription.billing_address_zipcode}}</h1>
                            </template>
                        </template>
                    </div>
                </div>

                <div class="col-md-6" v-if="editcard">
                    <div class="orderSubProfileItem">
                        <a class="addMore" @click.prevent="newcardInit" href=""><b-icon icon="plus-circle"></b-icon> Add new card</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <b-modal id="deletecardwarning" hide-footer hide-header>
        <div class="d-block text-center mt-5">
            <h3><b-icon icon="credit-card-fill"></b-icon></h3>
            <h3>Delete Card</h3>

            <p>This card will be permanently removed and cannot be undone.</p>
        </div>

        <button 
            class="btn btn-outline-primary btn-round block mt-5" 
            @click="$bvModal.hide('deletecardwarning')">
            Cancel
        </button>
        <b-button class="mt-4 mb-5" variant="primary"  block @click="deletecard">Continue</b-button>
    </b-modal>
    
    <b-modal id="changedefault" hide-footer hide-header>
        <div class="d-block text-center mt-5">
            <h3><b-icon icon="credit-card-fill"></b-icon></h3>
            <h3>Changing Card</h3>

            <p>You are changing default credit card. Charges will be billed to this card ending in <span v-if="tosetdefault" class="cardtochange">{{tosetdefault.card_last_four_digit}} {{tosetdefault.card_expiry | formatcardexpiration}}</span>.</p>
        </div>

        <button
            class="btn btn-outline-primary btn-round block mt-5" 
            @click="canceldefaultchange">
            Cancel
        </button>
        <b-button 
            class="mt-4 mb-5" 
            variant="primary"  
            block 
            @click="$bvModal.hide('changedefault')">Continue</b-button>
    </b-modal>
</div>
</template>

<script>

/**
 * Declerations
 */

// Mixins
import {gmapmixins} from '@/mixins/gmapmixins'
import {cardconnectmixins} from '@/mixins/cardconnectmixins'

// Helpers
import {
        newJob, 
        deleteCollection,
        addUpdateCollection,
        updateCollection
    } from '@/helpers/localbase'

// Plugins
import axios from 'axios'
import _ from 'lodash'

export default {
    mixins : [gmapmixins, cardconnectmixins],
    data() {
        return {
            newcard        : false,
            todeletecard   : null,
            tosetdefault   : null,
            defaultcard    : null,
            editcard       : false,
            editbilling    : false,
            billingaddress : {
                billing_address_street   : '',
                billing_address_city     : '',
                billing_address_state    : '',
                billing_address_zipcode  : '',
                billing_address_latitude : '',
                billing_address_longitude: ''
            }
        }
    },
    filters: {
        /**
         * Format card expiration
         * @example MM / YYYY
         */
        formatcardexpiration(date) {
            if(!date) return ''
            const year  = date.substr(0, 4);
            const month = date.substr(4, date.length);
            
            return `${month.length == 1 ? '0' : ''}${month} / ${year}`
        }
    },
    
    computed : {
        /**
         * User subscription
         */
        subscription() {
            let [sub] = this.$store.state.subscriptions
            return sub ? sub : null;
        },
        /**
         * Network status
         * 
         */
        isonline(){
            return this.$store.state.isonline
        },
        /**
         * Logged in user
         */
        user : {
            get() {
                return this.$store.state.user
            },
            set(user) {
                this.$store.commit('updateUser', user)
            }
        },
        /**
         * Active user credit card
         */
        usercreditcards : {
            get(){
                return this.$store.state.usercreditcards
            },
            set(list) {
                this.$store.commit('updateusercreditcards', list);
            }
        },
        /**
         * Card validation
         */
        disablesave() {
            let notvalid = true;

            if(this.cardtoken) {
                if(this.cardtoken.card_token) {
                    notvalid = false;
                } else 
                if(this.cardtoken.card_expiry) {
                    notvalid = false;
                } else 
                if(this.cardtoken.card_name) {
                    notvalid = false;
                } else
                if(this.cardtoken.card_last_four_digit) {
                    notvalid = false;
                }
            }

            return notvalid
        }
    },
    methods : {
        /**
         * Get default card
         */
        getdefaultcard() {
            console.log('what is creditcard', this.usercreditcards)
            const card = this.usercreditcards.find(uc => uc.is_default)
            if(card) {
                this.defaultcard = card.id
            } else {
                // none is default card select first card to be the default
                const [willbedefault] = this.usercreditcards
                if(willbedefault) {
                    this.tosetdefault = willbedefault
                    this.defaultcard  = willbedefault.id
                    this.setdefault()
                }
            }
        },
        /**
         * Default card change
         *
         */
        defaultcardchange(card) {
            this.tosetdefault = card
            this.$bvModal.show('changedefault')
        },
        /**
         * Get billing address and assign to local state
         * and initialize autocomplete function
         */
        initeditbilling() {
            this.editbilling = true

            /**
             * Get billing address data and assign to local state
             */

            this.billingaddress  = {
                billing_address_street   : this.subscription.billing_address_street,
                billing_address_city     : this.subscription.billing_address_city,
                billing_address_state    : this.subscription.billing_address_state,
                billing_address_zipcode  : this.subscription.billing_address_zipcode,
                billing_address_latitude : this.subscription.billing_address_latitude,
                billing_address_longitude: this.subscription.billing_address_longitude
            }

            this.autocompleteaddress()


        },
          /**
         * autocomplete place will query from google map api to get address suggestion.
         * @param {DOM} inputbox input box where the autocomplete will trigger
         */
        autocompleteaddress : _.debounce(function () {
            const inputbox = document.getElementById('autocompletesboxbilling');

            console.log('auto', inputbox)

            if(inputbox) {
                /**
                 * Callback
                 * Process return data from autocomplete address
                 */
                const callback = (data) => {
                   this.$nextTick(() => {
                        /**
                         * get latitude and longtitude
                         */
                        this.billingaddress.billing_address_latitude  = data.geometry.location.lat();
                        this.billingaddress.billing_address_longitude = data.geometry.location.lng();

                        /**
                         * get street, city, state, zipcode
                         */
                        // get street
                        const streetnumber = data.address_components.find(d => d.types.includes('street_number'));
                        const street       = data.address_components.find(d => d.types.includes('street'));
                        const route        = data.address_components.find(d => d.types.includes('route'));
                        
                        this.billingaddress.billing_address_street = `${streetnumber ? streetnumber.short_name : ''} ${street ? street.short_name : ''} ${route ? route.long_name : ''}`;
                        
                        // get city
                        const city                                       = data.address_components.find(d => d.types.includes('locality') || d.types.includes('postal_town'));
                              this.billingaddress.billing_address_city = city.long_name;

                         // get state
                        const state                                       = data.address_components.find(d => d.types.includes('administrative_area_level_1'));
                              this.billingaddress.billing_address_state = state.short_name;


                        // get postal_code
                        const postalcode                                    = data.address_components.find(d => d.types.includes('postal_code') || d.types.includes('postal_code_suffix'));
                              this.billingaddress.billing_address_zipcode = postalcode.short_name;
                   });

                }

                this.autocompletedress(inputbox, callback);
            }
        }, 300),
        /**
         * Update billing address
         */
        async updatebillingaddress() {
            const url = `/update_billing_address`;

            const res = await axios.post(url, this.billingaddress);

            if(res.data.success) {
                this.$store.dispatch('getSubscriptions')
                this.editbilling = false;
            } else if(!this.isonline) {
                /**
                 * If offline add request to job
                 * 
                 */
                newJob({
                    url   : url,
                    method: "POST",
                    params: this.billingaddress,
                    callback : (data, options) => {
                        if(data.success) {
                            options.store.store.dispatch('getSubscriptions');
                        }
                    }
                })
            }
        },  
        /**
         * Cancel changing default card
         * 
         */
        canceldefaultchange() {
            const list = this.usercreditcards.map(card => {
                if(this.tosetdefault.id == card.id) {
                    card.is_default = false;
                }

                return card;
            })
            
            const prevdefaultcard      = this.usercreditcards.find(c => c.is_default)
                  this.defaultcard     = prevdefaultcard ? prevdefaultcard.id : this.defaultcard
                  this.usercreditcards = list;
                  this.tosetdefault    = null;
            this.$bvModal.hide('changedefault');
        },
        /**
         * Set new default creditcard
         * set default false previously default card
         * update indexed db
         */
        async setdefault() {
            let card            = this.tosetdefault;
                card.is_default = true;
            /**
             * If nothing change 
             * disable edit mode
             */
            if(!card) {
                this.editcard = false;
                return;
            }

            const url           = `/set_card_default/${card.id}`;
            const res           = await axios.post(url);


            if(res.data.success) {
                const olddefault            = this.usercreditcards.find(c => c.is_default);
                      olddefault.is_default = false;
                      this.editcard         = false;


                /**
                 * Update indexed db for
                 * Old default 
                 * and new default
                 */
                updateCollection({name : 'usercreditcards', filter: {id : olddefault.id}, data : olddefault});
                updateCollection({name : 'usercreditcards', filter: {id : card.id}, data : card});

                /**
                 * Set default false fot the rest of cards except with new default card
                 */
                const cclist = this.usercreditcards.map(c => {
                    if(c.id != card.id) {
                        c.is_default = false;
                    }
                    return c;
                })

                this.usercreditcards = cclist;
                
                

            } else if(!this.isonline) {
                /**
                 * If offline add request to job
                 */
                newJob({
                    url   : url,
                    method: 'POST'
                })
            }
        },
        /**
         * Add new card and init card connect
         */
        newcardInit() {
              //Initiatlize card connect
                this.newcard   = true;
                this.cardtoken = null; // reset
            const cardstyle = 'input {background-color : transparent}; label {font-size : 12px; font-weight: 800;}'
            this.initcardconnect(cardstyle);
        },
        /**
         * Deleting card
         */
        deletecard() {
            if(this.todeletecard) {
                const url = `/creditcards/${this.todeletecard.id}`;
                axios.delete(url);

                const newlist              = this.usercreditcards.filter(c => c.id != this.todeletecard.id);
                      this.usercreditcards = newlist;

                deleteCollection({name : 'usercreditcards', filter : {id : this.todeletecard.id}});

                this.$bvModal.hide('deletecardwarning');
                
                // if offline add request to job
                if(!this.isonline) {
                    newJob({
                        url     : url,
                        method  : 'DELETE',
                        params  : {id : this.todeletecard.id},
                        callback: (data, options) => {
                            /**
                             * Remove from store
                             * and indexeddb
                             */
                            if(data) {
                                const cardlist = options.store.state.usercreditcards;
                                const newlist  = cardlist.filter(c => c.id != options.job.params.id);

                                /**
                                 * Update store card list
                                 */
                                options.store.commit('updateusercreditcards', newlist);

                                /** 
                                 * remove record to index db
                                */
                                options.db.deleteCollection({name : 'usercreditcards', filter: {id : options.job.params.id}});
                            }
                        }

                    })
                }
            }
        },
        /**
         * Add new card
         * 
         */
        async createcard() {
            const url = '/creditcards';
            const res = await axios.post(url, this.cardtoken);

            if(res.data.success) {

                /**
                 * Update card list 
                 * and add new record to indexed db
                 */
                const newcard              = res.data.data;
                const newlist              = [...this.usercreditcards, newcard];
                      this.usercreditcards = newlist;

                
                addUpdateCollection({name : 'usercreditcards', data : newcard});
            } else if(!this.isonline) {
                /**
                 * IF online add request to api job
                 */
                newJob({
                    url     : url,
                    method  : "POST",
                    params  : this.cardtoken,
                    callback: (data, options) => {
                        if(data.success) {
                            const newcard  = data.data;
                            const cardlist = options.store.state.usercreditcards;
                            const newlist  = [...cardlist, newcard];

                            /**
                             * Update store card list
                             */
                            options.store.commit('updateusercreditcards', newlist);

                            /** 
                             * Add new record to index db
                            */
                           options.db.addUpdateCollection({name : 'usercreditcards',  data : newcard});
                        }
                    }
                })
            }

            // resets
            this.cardtoken = null;
            this.newcard   = false;
        }
    },
    /**
     * Run function before component render
     */
    async beforeMount() {
        // Get user creditcards
        if(this.user) {
            await this.$store.dispatch('getcreditcards', this.user.id );
            this.getdefaultcard()
        }
    }
}
</script>

<style lang="scss">
@import '@/scss/_settings.scss';


#changedefault {

    .cardtochange {
        color : $primary-color;
    }
}

.orderSubProfileItem {
    

    h2 {
        display: flex;
        

        .action {
            color      : $primary-color;
            margin-left: 15px;
            cursor     : pointer;
        }
    }

    .form-control {
        border-color    : transparent;
        padding-left    : 0;
        background-color: transparent;
        font-size       : 25px;
        font-weight     : 300;

        &:focus {
            outline   : none;
            box-shadow: none;
        }
    }

    .editfooteraction {
        .btn {
            margin-right : 15px;
            margin-top : 15px;
        }
    }

    .addMore {
        svg {
            margin-right:  10px;
        }
    }

    input {
        background-color: transparent;
        border-color    : transparent;
        padding-left    : 0;

        &:focus {
            outline         : none;
            border-color    : transparent;
            box-shadow      : none;
            background-color: transparent;
        }
    }

    label {
        font-size    : 12px;
        font-weight  : 800;
        margin-bottom: 0;
    }

    .newcardactions {
        .btn {
            margin-right : 15px;
            padding-left : 15px;
            padding-right: 15px;
        }
    }

    .newcardform {
        margin-top : 30px;
    }

    iframe {
        min-height: 200px;
    }

    .usercreditcards {
        &.viewmode {
            .custom-radio {
                .custom-control-input ~ .custom-control-label {
                    padding-left : 20px;
                }
            }
        }

        .input-group-prepend {
         
            .defaultcard {
                display    : flex;
                align-items: center;
                color      : $primary-color;
                font-size  : 20px;
            }
        }

        .custom-radio {

            &.defaultcard {
                padding-left : 5px;
            }

            label {
                &::after, &::before {
                    top : 10px;
                }
            }

            .custom-control-input:disabled ~ .custom-control-label {
                margin-left : -20px;

                &::after, &::before {
                    display: none;
                }
            }

            .custom-control-input:checked ~ .custom-control-label {
                &::after, &::before {
                    display: none;
                }
            }

            
        }

        h1 {
            display    : flex ;
            align-items: center;

            img {
                margin-right: 15px;
                max-width   : 40px;
                position    : relative;
                top         : 3px;
            }

            .removecard {
                margin-left: 10px;
                cursor     : pointer;
                font-size  : 15px;
            }
        }
    }

    .cardfooteraction {
        .btn {
            margin-right : 10px;
        }
    }
}
</style>